// removed by extract-text-webpack-plugin
module.exports = {"container":"_3dtgUKz5szkYtT8xu-i2Aq","inner":"_1VIAV1i15Rq2TaifEXRvna"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-38912f97","scoped":false,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"sourceMap":true}!./src/components/rep-call/shared/back-to-call/back-to-call.less
// module id = IH1n
// module chunks = 1